import useThemeStore from "(store)/themeStore";
import AuthCode from "react-auth-code-input";
import "styles/AuthInput.css";

const AuthInput = ({ onChange, label, length }) => {
  const theme = useThemeStore(state=> state.theme);
  return (
    <div className="flex flex-col items-center">
      {label && <p className="text-2xl font-semibold">{label}</p>}
      <AuthCode
        onChange={onChange}
        length={length || 6}
        allowedCharacters="alphanumeric"
        inputClassName={`inputAuth ${theme === 'dark' ?"bg-[#020617] !border-gray-800 !text-white focus:bg-white focus:text-black":"bg-white"}`}
        containerClassName="inputCont"
      />
    </div>
  );
};

export default AuthInput;
